import React, { useEffect, useState, useCallback } from "react";
import { PublicClientApplication } from "@azure/msal-browser";
import { loginRequest } from "../src/constants/authConfig";
import { useMsal } from "@azure/msal-react";
import appConfig from "./constants/config";

// export const msal = new PublicClientApplication(msalConfig);

interface AuthComponentProps {
  onAuthChange: (isLoggedIn: boolean) => void;
}



export const AuthComponent: React.FC<AuthComponentProps> = ({
  onAuthChange,
}) => {
  const { instance: msalInstance } = useMsal();
  const [accessToken, setAccessToken] = useState<string | null>(null);

  const initializeMsal = useCallback(async () => {
    try {
      // Initialize the PublicClientApplication instance
      await msalInstance.initialize();
      const response = await msalInstance.handleRedirectPromise();

      //Clear impersonate flag when re-login
      localStorage.removeItem("IsImpersonated");
      if (response) {
        console.log("Login successful: =================  ", response);
        msalInstance.setActiveAccount(response.account);
        setAccessToken(response.accessToken);
        localStorage.setItem("token", response.accessToken);
        localStorage.setItem("ADUsername", response.account.username);
        localStorage.setItem(
          "ADProfileName",
          response.account.name || "Your Profile"
        );
        onAuthChange(true);
      } else {
        const account = msalInstance.getActiveAccount();
        if (!account) {
          await msalInstance.loginRedirect(loginRequest);
        }
      }
    } catch (error) {
      console.error("Error during authentication process:", error);
    }
  }, [onAuthChange]);

  useEffect(() => {
    initializeMsal();
  }, [initializeMsal]);

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        margin: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    ></div>
  );
};

export const useLogout = () => {
  const { instance: msalInstance } = useMsal();

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    clearCookies();
    msalInstance.logoutRedirect({
      postLogoutRedirectUri: msalInstance.getConfiguration().auth.postLogoutRedirectUri,
    });
  };

  const clearCookies = () => {
    // This function clears cookies. Implement as needed based on your use case.
    document.cookie.split(';').forEach((c) => {
      document.cookie = c.replace(/^ +/, '').replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
    });
  };

  return handleLogout;
};

// export default AuthComponent;
